// extracted by mini-css-extract-plugin
export default {"spinnerWrap":"paypal-button_spinnerWrap__2ad69","button":"paypal-button_button__9a4eb","spinner":"paypal-button_spinner__1dce1"};